import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

/** Middle-dot separator for compact header triggers and inline summaries. */
export const DotSeparator: React.FC = () => {
  const { classes } = useStyles();
  return (
    <Box component="span" className={classes.root} aria-hidden>
      ·
    </Box>
  );
};

const useStyles = makeStyles()(() => ({
  root: {
    paddingInline: 4,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1,
    color: 'rgba(0, 0, 0, 0.4)',
  },
}));
